import { __rest } from "tslib";
import React, { forwardRef } from 'react';
import { tv } from 'tailwind-variants';
const pulse = tv({
    base: [
        'relative',
        'text-gray-400',
        'before:block',
        'before:absolute',
        'before:top-0',
        'before:left-0',
        'before:w-full',
        'before:h-full',
        'before:animate-attention',
    ],
    variants: {
        rounded: {
            md: ['before:rounded-md'],
            full: ['before:rounded-full'],
        },
    },
    defaultVariants: {
        rounded: 'md',
    },
});
const BtwPulse = forwardRef(function BtwPulse(props, ref) {
    const { children, className, shouldPulse, rounded } = props, rest = __rest(props, ["children", "className", "shouldPulse", "rounded"]);
    if (shouldPulse) {
        return (React.createElement("div", Object.assign({ className: pulse({ className, rounded }), ref: ref }, rest), children));
    }
    return React.createElement(React.Fragment, null, children);
});
export { BtwPulse };
